import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-footer',
  imports: [FontAwesomeModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  copyright = faCopyright

  isFooterSectorsOpen: boolean = false
  isFooterProductsOpen: boolean = false

  toggleDrop(type: string) {
    type == 'sectors' ? this.isFooterSectorsOpen = !this.isFooterSectorsOpen : this.isFooterProductsOpen = !this.isFooterProductsOpen;
  }

}


